import moment from 'moment';

export const daysAreEqual = (date1, date2) => {
  return (
    moment(date1).format('DD-MM-YYYY') === moment(date2).format('DD-MM-YYYY')
  );
};

export const daysInMonth = (date) => {
  return new Date(moment(date).endOf('month')).getDate();
};

export const periodOfMonth = (date) => {
  return {
    start: new Date(moment(date).startOf('month')),
    end: new Date(moment(date).endOf('month')),
  };
};

export const dateIsEmpty = (date) => {
  return typeof date === 'string'
    ? date.split('/').join('').trim().length === 0
      ? true
      : false
    : true;
};

export const getDataLenght = (date) => {
  return typeof date === 'string' ? date.split('/').join('').trim().length : 0;
};

export const periodOfWeek = (date) => {
  return {
    start: new Date(moment(date).startOf('week')),
    end: new Date(moment(date).endOf('week')),
  };
};

export const periodOfWordWeek = (date) => {
  return {
    start: new Date(moment(date).startOf('week').add(1, 'days')),
    end: new Date(moment(date).endOf('week').subtract(1, 'days')),
  };
};

export const getMomentDifference = (start, end, format) => {
  const duration = moment.duration(
    moment(end, format).diff(moment(start, format))
  );
  return duration.asMinutes();
};

export const diferenceMonths = (dateInicio, dateFim) => {
  if (!dateInicio || !dateFim) return 0;
  const i = moment(dateInicio, 'DD/MM/YYYY');
  const f = moment(dateFim, 'DD/MM/YYYY');
  return f.diff(i, 'months').toFixed();
};

export const convertDateToIso = (data) => {
  if (data) 
    return moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD');
  return null;
}
